/* eslint-disable no-underscore-dangle */
import React, { useState,useEffect } from 'react';
import axios from 'axios';
import './index.css';
import { Link, useParams } from 'react-router-dom';
import CustomerContainer from './CustomerContainer';
import ThankReviews from '../Reviews/ThankReviews';
import Feedback from './Feedback';
import Loader from '../Loader';
import Header from '../Header';
import WriteExperience from './WriteExperience';

function CustomerExperience({ baseURL }) {
  const {
    linkid, templateid, contactid, type, rate, 
  } = useParams();

  const [experienceGetData,setExperienceGetData] = useState(null);
  const [gotData, setGotData] = useState(false);
  const [page, setPage] = useState(1);
  const [rateValue, setRateValue] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    ExperinceApiHandler();
  },[]);
  
  useEffect(() => {
    // console.log('type====',type,experienceGetData?.template?.experience_type_,rate);
    if (type === 'email' && gotData === 'success') {
      handleFeedbackSubmit();
      if (experienceGetData?.template?.show_review_request_page === true) {
        setPage(2);
      }
      if (experienceGetData?.template?.show_review_request_page === false) {
        setPage(3);
      }   
      if (experienceGetData?.template?.experience_type_ === '_nps' && rate < 10) { 
        setPage(3);       
        // setPage((prev)=>prev+2);
        // console.log('_nps rate=>',rate,page);
      }
      if (experienceGetData?.template?.experience_type_ === '5_star_rating' && rate < 5) {
        setPage(3);
        // console.log('5_star_rating rate=>',rate,page);
      }
      if (experienceGetData?.template?.experience_type_ === 'sentiment' && rate > 1) {
        setPage(3);
        // console.log('sentiment rate=>',rate,page);
      }         
    }
  },[gotData]);

  const ExperinceApiHandler = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/testing/experience/${linkid}/${templateid}/${contactid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      // console.log(response,'this is response');
      if (response.data.status === 'success') {
        setGotData(response?.data?.status);
        setExperienceGetData(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error,'error');
    }
  };

  const openHandler = (value) => {
    setRateValue(value);
    handleFeedbackSubmit(value);
    if (experienceGetData?.template?.experience_type_ === '_nps' && (value === 10)) {
      if (experienceGetData?.template?.show_review_request_page === true) {
        setPage(2);
      }
    } else if (experienceGetData?.template?.experience_type_ === '_nps' && (value < 10)) {
      setPage(4);
    }
    if (experienceGetData?.template?.experience_type_ === '5_star_rating' && (value === 5)) {
      if (experienceGetData?.template?.show_review_request_page === true) {
        setPage(2);
      }
    } else if (experienceGetData?.template?.experience_type_ === '5_star_rating' && (value < 5)) {
      setPage(4);
    }
    if (experienceGetData?.template?.experience_type_ === 'sentiment' && (value === 1)) {
      if (experienceGetData?.template?.show_review_request_page === true) {
        setPage(2);
      }
    } else if (experienceGetData?.template?.experience_type_ === 'sentiment' && (value > 1)) {
      setPage(4);
    }
    if (experienceGetData?.template?.show_review_request_page === false) {
      setPage(2);
    }
  };

  // useEffect(()=>{
  //   console.log('type====',type,experienceGetData?.template?.experience_type_,rate);
  //   if(type === 'email'){
  //     if(experienceGetData?.template?.experience_type_ === '_nps' && rate < 8){
  //       setPage(3);
  //     }
  //     if(experienceGetData?.template?.experience_type_ === '5_star_rating' && rate < 4){
  //       setPage(3);
  //     }
  //     if(experienceGetData?.template?.experience_type_ === 'sentiment' && rate > 1){
  //       setPage(3);
  //     }
  //   }    
  // },[])

  const getType = (val) => {
    switch (val) {
      case '_nps':
        return 'nps';
      case 'sentiment':
        return 'experience';
      case '5_star_rating':
        return '5_star';
      default:
        return val;
    }
  }; 

  function getTemplateType(template) {
    if (template.experience_type_) {
      return template.experience_type_;
    }
    if (template.experience_type) {
      return template.experience_type;
    }
    return '';
  }

  // useEffect(() => {
  //   if(gotData === 'success'){
  //     handleFeedbackSubmit();
  //   }    
  // },[gotData]);

  const handleFeedbackSubmit = async (value) => {
    console.log(value);
    const formData = {
      contact_id: contactid,
      value: type === 'sms' ? value : rate,
      sent_via: type,
      type: getType(getTemplateType(experienceGetData?.template)),
    };
    const res = await axios.post(`${baseURL}/testing/create-customer-experience`,formData);
    console.log(' handleFeedbackSubmit res', res);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="qs-page">
      <div className="qs-card min-h-[500px]">
        <Header 
          logo={experienceGetData?.display?.email_logo}
          headerColor={experienceGetData?.display?.email_header_color}
          headerTextColor={experienceGetData?.display?.email_header_text_color}
          companyName={experienceGetData?.name}
          ratingValue={(experienceGetData?.rating_average)}
          reviewCount={experienceGetData?.review_count}
        />
        <div className="qs-card-body flex-1">
          {page === 1 && (
          <div>
            {type === 'sms' && (
              <Feedback experienceGetData={experienceGetData} openHandler={openHandler} />
            )}            
          </div>
          )}
          {page === 2 && (
          <CustomerContainer 
            baseURL={baseURL}
            setPage={setPage}
            experienceGetData={experienceGetData}
            typePage="cx"
          />
          )}
          {page === 3 && <ThankReviews baseURL={baseURL} value={rateValue} />}
          {page === 4 && (
            <WriteExperience 
              setPage={setPage} 
              baseURL={baseURL} 
              data={experienceGetData} 
            />
          )}
        </div>
        <div className="qs-footer-note">
          To unsubscribe click this 
          {'  '}
          <Link 
            className="qs-link pl-1"
            to={`/unsubscribe/${experienceGetData?.company_id}/${contactid}/${type}`}
          >
            link
          </Link> 
        </div>
      </div>
    </div>
  );
}

export default CustomerExperience;
